import { IconProps } from "./types";

const ExternalLinkIcon = ({
  className,
  width = 24,
  height = 24,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.5 1h-5A2.5 2.5 0 0 0 1 3.5v15A2.5 2.5 0 0 0 3.5 21h15a2.5 2.5 0 0 0 2.5-2.5v-5M11 11 21 1m0 0v6.25M21 1h-6.25"
      stroke="inherit"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExternalLinkIcon;
